module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\r\n<!-- 数字翻页 -->\r\n<div class="pages-number">\r\n    <a><i class="iconfont icon-arrow-left"></i></a>\r\n    <a class="active">1</a>\r\n    <a>2</a>\r\n    <a>3</a>\r\n    <a>4</a>\r\n    <a>5</a>\r\n    <a><i class="iconfont icon-arrow-right1"></i></a>\r\n</div>';

}
return __p
}